<template>
  <div v-if="isQuizActive==true" class="quizscore">
    <router-link :to="{ name: 'Statistik'}">
      <img src="../assets/EKS-Score.svg" /><span class="toppercent">{{ prozente }}</span>
    </router-link>
  </div>
</template>
<script type="text/babel">
export default {
  name: 'PunkteCounterTop',
  data() {
    return {
      //currentroute: null,

    }
  },
  computed: {
    isQuizActive: function () {


      return this.$root.solvedQuizes.length > 0


    },
    prozente: function () {
      let antworten = this.$root.solvedQuizes.length

      if (antworten == 0) return '-- %'

      let punktePlus = 0

      this.$root.solvedQuizes.forEach((element, index) => {
        if (element.answerRight === true) {
          punktePlus++
        }
      })

      let prozent = punktePlus / antworten * 100

      let gesamt = prozent.toFixed(2) + '%'

      return gesamt.replace('.',',')

    },
    punktePostitiv: function () {
      // this.$root.solvedQuizes
      let punkte = 0
      this.$root.solvedQuizes.forEach((element, index) => {
        if (element.answerRight === true) {
          punkte++
        }
      })

      return punkte

    },
    punkteNegativ: function () {
      // this.$root.solvedQuizes
      let punkte = 0
      this.$root.solvedQuizes.forEach((element, index) => {
        if (element.answerRight === false) {
          punkte++
        }
      })

      return punkte

    },
    zeit: function () {
      let zeit = 0.0
      this.$root.solvedQuizes.forEach((element, index) => {
        //console.log(element);
        let ed = new Date(element.endDate)
        let sd = new Date(element.startDate)
        zeit += (ed.getTime() - sd.getTime()) / 1000

      })

      return zeit.toFixed(2) + ' Sekunden'

    },
  },


}
</script>

<style lang="scss" scoped>
.quizscore {
  margin-left: 40px;
  vertical-align: bottom;
  display: inline-block;

  @media screen and (max-width: 560px) {
    margin-left: 10px;
    margin-bottom: -3px;
  }
  @media screen and (max-width: 480px) {
    margin-bottom: 0px;
  }

  img {
    width: 45px;
    box-sizing: border-box;

    @media screen and (max-width: 560px) {
      width: 35px;
      padding-bottom: 5px;
    }
    @media screen and (max-width: 480px) {
      width: 25px;
      padding-bottom: 2px;
    }
    @media screen and (max-width: 340px) {
      width: 20px;
      padding-bottom: 4px;
    }
  }

  .toppercent {
    margin-left: 10px;
    color: #b3905a;
    font-size: 22px;

    display: inline-block;
    padding-bottom: 5px;

    @media screen and (max-width: 560px) {
      font-size: 20px;
    }
    @media screen and (max-width: 480px) {
      font-size: 16px;
      padding-bottom: 2px;
    }
  }
}

.topicon {
  color: white;
  margin-left: 20px
}

#top {
  border-radius: 9999px;
  padding: 5px;
  background-color: #eee;
  color: #000;
}
</style>
